export const BaseDict = {
    NoData: "No Data",
    ShowAll: "Show All",
    HideAll: "Hide All",
    SelectedLeaguesLimitReached: "Maximum number of selected leagues reached!",
    LiveSteaming: "LiveStream",
    LiveLabel: "Live",
    CouponLeague: "Coupon Leagues",
    AllLeagues: "All Leagues",
    TopLeagues: "Top Leagues",
    CreateCoupon: "Create Coupon"
};
//# sourceMappingURL=dict.js.map